<template>
  <v-dialog v-model="visible" width="600" ClickOutside="onClickOutside">
    <v-card>
      <v-card-title class="grey lighten-4">{{ title }}</v-card-title>

      <v-card-text>
        <v-container class="fill-height">
          <v-row align="center">
            <v-col>
              <span v-html="content"></span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close()">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      content: "",
      visible: false,
      queue: [],
      showTime: 0,
    };
  },
  created() {
    this.$eventBus.$on("show-dialog", ({title, content}) => {
      let d = new Date();
      this.showTime = d.getTime();

      let obj = { title: title, content: content };
      this.queue.push(obj);

      this.title = title;
      this.content = content;
      this.visible = true;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("show-dialog");
  },
  methods: {
    close() {
      this.queue.pop();
      if (this.queue.length == 0) {
        this.visible = false;
      } else {
        let obj = this.queue[this.queue.length - 1];
        this.title = obj.title;
        this.content = obj.content;
      }
    },
    onClickOutside() {
      let d = new Date();
      //даже invisible диалог ловит это событие
      if (d.getTime() - this.showTime > 500) {
        this.visible = false;
        this.queue = [];
      }
    },
  },
};
</script>
<style scoped>
.v-application .v-card__text {
  min-height: 100px;
}
</style>